import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GenericPayloadService } from '../../../../../../libs/shared/libraries/generic-shared-library/src/lib/shared-services/generic-payload.service';

@Injectable({
  providedIn: 'root'
})
export class CustomPayloadService {
  private router = inject(Router);

  constructor(private genericService: GenericPayloadService) { }

  private buildPayload(requestParamFilters: any, dashboardName: string, isTable = false): any {
    let staticFilters: any[] = [];
    const customerNameValue = requestParamFilters?.['customer_name'];

    // === Dashboard-specific static filters ===
    if (dashboardName === 'customer-overview') {
      if (!customerNameValue && (!Array.isArray(customerNameValue) || customerNameValue.length > 0)) {
        staticFilters = [{
          attributeName: 'customer_name',
          operator: '!=',
          attributeValues: ['NA'],
          logicalOperator: 'AND'
        }];
      }
    } else if (dashboardName === 'cspec-bridge') {
      if (!customerNameValue && (!Array.isArray(customerNameValue) || customerNameValue.length > 0)) {
        staticFilters = [{
          attributeName: 'latest_shop_order_flag',
          operator: '=',
          attributeValues: [true],
          logicalOperator: 'AND'
        }];
      }
    } else if (dashboardName !== 'opportunity-overview') {
      if (!customerNameValue && (!Array.isArray(customerNameValue) || customerNameValue.length > 0)) {
        staticFilters = [
          { attributeName: 'customer_name', operator: '!=', attributeValues: ['NA'], logicalOperator: 'AND' },
          { attributeName: 'latest_shop_order_flag', operator: '=', attributeValues: [true], logicalOperator: 'AND' }
        ];
      }
    }

    const payload = this.genericService.buildPayload(requestParamFilters, staticFilters);

    // === Table-specific logic ===
    if (isTable) {
      if (dashboardName === 'cspec-sales-bridge') {
        payload.filter.where = payload.filter.where.filter((elm: any) =>
          ['customer_name', 'customer_spec'].includes(elm.attributeName)
        );
      } else {
        payload.filter.where = payload.filter.where.filter((elm: any) => elm.attributeName === 'customer_spec');
      }

      if (payload?.filter?.where?.length > 0) {
        payload.filter.where[payload.filter.where.length - 1].logicalOperator = '';
      }
    }

    return payload;
  }

  getConfig(url: string, filters?: any, method: 'post' | 'get' = 'post', isTable = false): Observable<any> {
    const useQueryParams = filters?.useQueryParams === true;
    if (filters && 'useQueryParams' in filters) delete filters.useQueryParams;

    const currentPath = this.router.url.split('?')[0];
    const dashboardName = currentPath.startsWith('/') ? currentPath.substring(1) : currentPath;

    const payload = this.buildPayload(filters?.requestParams || {}, dashboardName, isTable);
    const queryParams = useQueryParams ? this.genericService.buildQueryParams(filters?.queryParams || {}) : new HttpParams();

    return this.genericService.sendRequest(url, payload, method, queryParams);
  }

  getDropdownOptions(url: string, payload: any): Observable<any> {
    return this.genericService.sendRequest(url, payload, 'post', new HttpParams());
  }

  getData(url: string): Observable<any> {
    return this.genericService.sendRequest(url, {}, 'get', new HttpParams());
  }
}